//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 
import {get,post} from '../api'
export default {
    mounted() {
      this.getAutoHeight();
      const self=this;
      window.onresize=function(){
        self.getAutoHeight();
      };
      this.lxTags=["毛坯","成品"];
      this.checkLX=this.lxTags[0];
    },
    watch: {
      'checkLX': {
        // let that=this;
        handler(newValue, oldValue) {
          // console.log(`checkLX from ${oldValue} to ${newValue}`);
          // this.fileInfo={that.checkLX:""};
          // console.log(this.checkLX);
          this.fileTip="只能上传Excel文件";
          this.fileList=[];
          this.getData(newValue,1);
          this.getItems();
          // this.CPInfo=[];
          // this.MPInfo=[];
          this.Importitle=this.checkLX+"入库("+this.fileTip+")";
          this.Edititle=this.checkLX+"入库";
        },
        deep: true
      }
    },
    methods: {
      getData(_checkLX,pageindex){
        if(pageindex!==undefined){
          this.pageIndex=pageindex;
        }
        if(_checkLX=="成品"){
            this.uploadUrl=process.env.BASE_URL+"SearchCenter/UploadCPFile";
            post('/CPInfo/Query', {keyFilter:this.search,pageindex:this.pageIndex,pagesize:6}).then(response => {
              // console.log(response);
              if(response.code==1){
                this.CPInfo=response.data||[];
                this.pageCount=response.PageCount;
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }
          else if(_checkLX=="毛坯"){
            this.uploadUrl=process.env.BASE_URL+"SearchCenter/UploadMPFile";
            post('/MPInfo/Query', {keyFilter:this.search,pageindex:this.pageIndex,pagesize:6 }).then(response => {
              console.log(response);
              if(response.code==1){
                this.MPInfo=response.data||[];
                this.pageCount=response.PageCount;
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }
      },
      onPreSearch(){
        if(this.pageIndex<=1)return;
        this.pageIndex=this.pageIndex-1;
        this.getData(this.checkLX);
      },
      onNextSearch(){
        if(this.pageIndex>=this.pageCount)return;
        this.pageIndex=this.pageIndex+1;
        this.getData(this.checkLX);
      },
      goHome(){
        this.$router.push({ path: '/' });
      },
      submitUpload() {
        // if(this.fileList.length==0){
        //    this.$message({
        //     message: '请先选择要上传的Excel文件',
        //     type: 'warning'
        //   });
        //   return;
        // }
        this.$refs.upload.submit();
      },
      dataSave(){
        if(this.checkLX=="成品"){
            post('/CPInfo/AddBatch', this.CPInfoImp).then(response => {
              // console.log(response);
              if(response.code==1){
                this.$message({
                  message: response.data,
                  type: 'info'
                });
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
        }
        else if(this.checkLX=="毛坯"){
          post('/MPInfo/AddBatch', this.MPInfoImp).then(response => {
            // console.log(response);
            if(response.code==1){
              this.$message({
                message: response.data,
                type: 'info'
              });
            }
            else if(response.code==0){
              this.$message({
                message: response.data,
                type: 'error'
              });
            }
          }).catch(error => {
            console.log(error);
          });
        }
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleChange(file) {
        let productLX=this.checkLX;
        this.fileInfo={productLX:this.checkLX};
        // console.log(file);
        // 结构获取文件名
        let { name } = file;
        // 正则校验文件格式
        let result = [".xlsx",".xls"].includes(name.substring(name.lastIndexOf(".")).toLowerCase());
        // console.log(result);
        if(!result) {
          this.$message({
            message: '上传文件格式不符合要求',
            type: 'warning'
          });
          this.fileTip="只能上传Excel文件";
          this.fileList=[];
          return;
        }
        this.fileTip=name;
        // this.CPInfo=[];
        // this.MPInfo=[];
         this.Importitle=this.checkLX+"入库("+this.fileTip+")";
         this.Edititle=this.checkLX+"入库";
      },
      handleError(err, file, fileList) {
        this.$message({
            message: '文件上传失败',
            type: 'error'
          });
        console.log(err, file, fileList);
      },
      handleSuccess(response, file, fileList) {
         if(this.checkLX=="成品"){
            this.CPInfoImp=response.data;
          }
          else if(this.checkLX=="毛坯"){
            this.MPInfoImp=response.data;
          }
        console.log(response, file, fileList);
      },
       handleMPEdit(index, row) {
        this.EMPInfo=row;
        if(this.EMPInfo.JCBG==="有"){
          this.JCBG=true;
         }
         else{
          this.JCBG=false;
         }
         this.showEdit=true;
         this.ISAdd=false;
         console.log(index, row);
      },
      handleMPDelete(index, row) {
        console.log(index, row);
        this.$confirm('即将删除选中记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            post('/MPInfo/Del', [row]).then(response => {
              // console.log(response);
              if(response.code==1){
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getData(this.checkLX,1);
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
       handleCPEdit(index, row) {
         this.ISAdd=false;
         this.ECPInfo=row;
         this.showEdit=true;
         console.log(index, row);
      },
      handleCPDelete(index, row) {
        console.log(index, row);
         this.$confirm('即将删除选中记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true
          }).then(() => {
            post('/CPInfo/Del', [row]).then(response => {
              // console.log(response);
              if(response.code==1){
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.getData(this.checkLX,1);
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
      },
      handleClose(){
        this.showImport=false;
        this.showEdit=false;
        this.MPInfoImp=[];
        this.CPInfoImp=[];
        this.getData(this.checkLX,1);
      },
      settingHandleClose(){
        this.showSetting=false;
      },
      handleMPSearch(){
        // console.log("search",this.search);
        this.getData(this.checkLX,1);
      },
      handleCPSearch(){
        // console.log("search",this.search);
        this.getData(this.checkLX,1);
      },
      editHandleClose(){
        this.EMPInfo={};
        this.ECPInfo={};
        this.showEdit=false;
        this.ISAdd=true;
      },
      editHandleSave(){
        if(this.checkLX=="成品"){
          if(this.ECPInfo.Count==""){
            this.ECPInfo.Count="0";
          }
          if(this.ISAdd==true){
              post('/CPInfo/Add', this.ECPInfo).then(response => {
              // console.log(response);
              if(response.code==1){
                this.$message({
                  type: 'success',
                  message: '成品入库成功!'
                });
                this.getData(this.checkLX,1);
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }
          else{
            post('/CPInfo/Update', this.ECPInfo).then(response => {
              // console.log(response);
              if(response.code==1){
                this.$message({
                  type: 'success',
                  message: '成品修改成功!'
                });
                this.getData(this.checkLX,1);
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }
        }
        else if(this.checkLX=="毛坯"){
          if(this.EMPInfo.Count==undefined || this.EMPInfo.Count==""){
            this.EMPInfo.Count="0";
          }
          if(this.EMPInfo.Weight==undefined || this.EMPInfo.Weight==""){
            this.EMPInfo.Weight="0";
          }
          if(this.JCBG==true){
            this.EMPInfo.JCBG="有";
          }
          else{
            this.EMPInfo.JCBG="无";
          }
          // console.log("this.EMPInfo",this.EMPInfo);
          if(this.ISAdd==true){
            post('/MPInfo/Add', this.EMPInfo).then(response => {
              // console.log(response);
              if(response.code==1){
                this.$message({
                  type: 'success',
                  message: '毛坯入库成功!'
                });
                this.getData(this.checkLX,1);
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }
          else{
            post('/MPInfo/Update', this.EMPInfo).then(response => {
              // console.log(response);
              if(response.code==1){
                this.$message({
                  type: 'success',
                  message: '毛坯修改成功!'
                });
                this.getData(this.checkLX,1);
              }
              else if(response.code==0){
                this.$message({
                  message: response.data,
                  type: 'error'
                });
              }
            }).catch(error => {
              console.log(error);
            });
          }
        }
        this.EMPInfo={};
        this.ECPInfo={};
        this.showEdit=false;
      },
      handleSettingClose(tag) {
        // console.log('删除',tag);
        let guid="0000-0000-0000-0000";
        this.items.forEach(element => {
          if(element.Name===tag){
            guid=element.Guid;
          }
        });
        post('/Dictionary/DelItem', {Guid:guid}).then(response => {
          // console.log(response);
          if(response.code==1){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            // this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            this.getItems();
          }
          else if(response.code==0){
            this.$message({
              message: response.data,
              type: 'error'
            });
          }
        }).catch(error => {
          console.log(error);
        });
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          // console.log('新增',inputValue);
          post('/Dictionary/AddItem', {ParentGuid:"DDColor",Name:inputValue}).then(response => {
            // console.log(response);
            if(response.code==1){
              this.$message({
                type: 'success',
                message: '新增成功!'
              });
              // this.dynamicTags.push(inputValue);
              this.getItems();
            }
            else if(response.code==0){
              this.$message({
                message: response.data,
                type: 'error'
              });
            }
          }).catch(error => {
            console.log(error);
          });
        }
        this.inputVisible = false;
        this.inputValue = '';
      },
      getItems(){
        post('/Dictionary/QueryItem', {ParentGuid:"DDColor"}).then(response => {
          // console.log(response);
          if(response.code==1){
            console.log(response);
            this.dynamicTags.splice(0, this.dynamicTags.length);
            this.items=response.data;
            this.items.forEach(element => {
              this.dynamicTags.push(element.Name);
            });
          }
          else if(response.code==0){
            this.$message({
              message: response.data,
              type: 'error'
            });
          }
        }).catch(error => {
          console.log(error);
        });
      },
      getAutoHeight(){
        this.$nextTick(()=>{
          // console.log("tag_xn height",tag_xn_height);
          this.heightCP =this.heightMP =(65*6)+"px";
          // console.log("height",this.heightMP);
          // console.log("window.innerHeight",window.innerHeight);
        });
      },
      getStyle(obj,attr){
        // 兼容IE浏览器
        let result = obj.currentstyle?
          obj.currentstyle[attr].replace("px","")
          :document.defaultView.getComputedStyle(obj, null)[attr].replace("px","");
        return Number(result);
      }
    },
    data () {
      return {
        lxTags:[],
        checkLX:"",
        MPInfo:[],
        CPInfo:[],
        MPInfoImp:[],
        CPInfoImp:[],
        fileList:[],
        fileInfo:{},
        fileTip:"只能上传Excel文件",
        uploadUrl:process.env.BASE_URL+"search/upload/",
        search: '',
        showImport:false,
        showEdit:false,
        showSetting:false,
        Importitle:"",
        Edititle:"",
        EMPInfo:{},
        ECPInfo:{},
        JCBG:false,
        ISAdd:true,
        dynamicTags: [],
        items:[],
        inputVisible: false,
        inputValue: '',
        heightMP:"200px",
        heightCP:"200px",
        pageIndex:1,
        pageCount:0
      }
    },
};



// WEBPACK FOOTER //
// ./src/components/WholeSaleCenter/ProductPage.vue